import { colors } from '../base/colors'

export const autocomplete = {
  styleOverrides: {
    root: {
      ['& .MuiAutocomplete-inputRoot']: {
        padding: 0,
        ['& .MuiAutocomplete-input']: {
          padding: '8px 12px'
        }
      },
      ['& .MuiChip-root']: {
        height: '24px',
        borderColor: colors.grey[400],
        backgroundColor: colors.grey[100],
        ['& .MuiChip-deleteIcon']: {
          color: colors.error.main
        }
      }
    }
  }
}
